import { connect } from 'react-redux';

import GroupParticipantListItem from './GroupParticipantListItem';
import { isInstructor } from '../../../../../core/selectors/classroom';
import { getFullName } from '../../../../utils/user';

const mapStateToProps = (state, props) => {
  const userData = props.user;
  const fullName = getFullName(userData);
  return {
    ...props,
    avatar: userData.avatar,
    email: userData.email,
    fullName,
    isInstructor: isInstructor(state, userData.id),
    action: props.action
      ? {
          label: props.action.label,
          onAction: () => props.action.onAction(userData.id),
          tooltip: props.action.tooltip,
        }
      : null,
  };
};

export default connect(mapStateToProps)(GroupParticipantListItem);
